var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"like-wraper"},[_c('div',{staticClass:"animation",class:_vm.animation ? 'start' : '',on:{"click":_vm.like}})])}
var staticRenderFns = []

export { render, staticRenderFns }